// 滿版圖片預覽彈窗

const FullImageModal = ({ dispatch, showFullImageModal, setShowFullImageModal, t }) => {
    return (
        <div
            className="modal cp bg-[rgba(0,0,0,0.7)]"
            onClick={() => dispatch(setShowFullImageModal(false))}
        >
            <div className="h-full center-center w-fit !max-h-[90vh] flex flex-col gap-y-[10px] items-end !overflow-hidden">
                <span className="text-btn1 text-[#fff] flex-shrink-0 h-[17px]">{t('CLOSE')}</span>
                <img
                    className="mx-auto max-h-[calc(100%-27px)] max-w-full object-contain"
                    src={showFullImageModal}
                    alt="gallery"
                />
            </div>
        </div>
    );
};

export default FullImageModal;
